/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Request_Access_SuccessInputs */



/**
* | output |
* | --- |
* | "Access requested. The owner has been notified." |
*
* @param {Artifact_Request_Access_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_request_access_success = /** @type {((inputs?: Artifact_Request_Access_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Request_Access_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zugriff angefragt. Der Eigentümer wurde benachrichtigt.")
	return /** @type {LocalizedString} */ ("Access requested. The owner has been notified.")
});